export type DropLootTier = 'hot' | 'warm' | 'cold';

export type DropLootZone = {
  name: string;
  x: number;
  z: number;
  tier: DropLootTier;
};

export const LOOT_TIER_COLORS: Record<DropLootTier, string> = {
  hot: '#ff4444',
  warm: '#ffaa44',
  cold: '#44aaff',
};

export const HEAT_ZONE_RADIUS_PX: Record<DropLootTier, number> = {
  hot: 14,
  warm: 10,
  cold: 7,
};

/** Loot-density hints aligned with WorldBuilder / minimap POI positions. */
export const POI_LOOT_ZONES: DropLootZone[] = [
  { name: 'Tilted', x: 2, z: -38, tier: 'hot' },
  { name: 'Retail Ridge', x: -35, z: 22, tier: 'hot' },
  { name: 'Pleasant Point', x: 40, z: 15, tier: 'warm' },
  { name: 'Lucky Wharf', x: -22, z: -28, tier: 'warm' },
  { name: 'Cracked Cove', x: 28, z: -22, tier: 'warm' },
  { name: 'Dusty Depot', x: 32, z: -32, tier: 'cold' },
  { name: 'Snobby Shores', x: -30, z: 30, tier: 'cold' },
  { name: 'Shifty Shafts', x: -18, z: -12, tier: 'warm' },
];
